import { EVENT_PROPERTY_TYPES } from "@redotech/redo-public-common/custom-events/create-custom-event";
import * as z from "zod";

export const eventPropertyTypeSchema = z.enum(EVENT_PROPERTY_TYPES);

export const getCustomEventPropertyKeys = {
  name: "getCustomEventPropertyKeys" as const,
  description:
    "Property keys and types seen on one custom event, for building its property filters.",
  mutates: false,
  input: z.object({ eventName: z.string() }),
  output: z.object({
    properties: z.array(
      z.object({ key: z.string(), type: eventPropertyTypeSchema }),
    ),
  }),
};
